import {Component, Input} from "@angular/core";
import {LabelConfig, RuleConfig} from "../../../../model/channels.model";

@Component({
  selector: "admin-channels-view-references",
  templateUrl: "./references.component.html",
  styleUrls: ["./references.component.css"]
})
export class AdminChannelsViewReferencesComponent {

  @Input() rules?: RuleConfig[];

}
